import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import LayoutAdmin from '../../components/layouts/LayoutAdmin';
import UserProfile from './UserProfile';
import { CompanyProfile } from './CompanyProfile';

export default function SettingsPage() {
  return (
    <LayoutAdmin header="Settings">
      <Tabs defaultValue="user">
        <TabsList>
          <TabsTrigger value="user">User Profile</TabsTrigger>
          <TabsTrigger value="company">Company Profile</TabsTrigger>
        </TabsList>
        <TabsContent value="user">
          <UserProfile />
        </TabsContent>
        <TabsContent value="company">
          <CompanyProfile />
        </TabsContent>
      </Tabs>
    </LayoutAdmin>
  );
}
